export default __webpack_public_path__ + "f71f54d87a0a937d2ddb818e4c892773.png";